import { render, staticRenderFns } from "./rebateActivity.vue?vue&type=template&id=87833b30"
import script from "./rebateActivity.vue?vue&type=script&lang=js"
export * from "./rebateActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports